module.exports = __webpack_public_path__ + "static/media/map-point-active.c431a6f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/map-point-active.png
// module id = 1133
// module chunks = 0